import { render, staticRenderFns } from "./teachProcessMain.vue?vue&type=template&id=376fa08c&scoped=true"
import script from "./teachProcessMain.vue?vue&type=script&lang=js"
export * from "./teachProcessMain.vue?vue&type=script&lang=js"
import style0 from "./teachProcessMain.vue?vue&type=style&index=0&id=376fa08c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376fa08c",
  null
  
)

export default component.exports